import cookie from 'js-cookie'

import { postApi } from 'api/fetchApi'
import { fetchApi5 } from 'api/index'
import { fetchAlbumsAttachSupportApi } from 'api/messengerSupport/fetchAlbumsAttachSupportApi'
import { LIMIT_PHOTOS } from 'api/photosProfileApi'

const s_post = cookie.get('s_post')

export const fetchAlbumsAttachSwitchApi = ({
  limit = LIMIT_PHOTOS,
  offset = 0,
  userHasRestrictions,
}: {
  limit?: number
  offset?: number
  userHasRestrictions: boolean
}) => {
  return userHasRestrictions
    ? fetchAlbumsAttachSupportApi(limit, offset)
    : fetchAlbumsAttachApi(limit, offset)
}

export const fetchAlbumsAttachApi = (limit: number, offset: number) => {
  return fetchApi5(
    `/users/albumAttach/photos/?s_post=${s_post}&limit=${limit}=&offset=${offset}`
  )
}

export const photosAlbumAttachDeleteApi = (photo: number[]) =>
  postApi('/photos/deleteAttachmentPhotos', {
    photosIds: photo,
  })
